import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import useInterval from '../hooks/useInterval';
const INTERVAL = 3000;
const DEFAULT_TIMEOUT = 5000;
export var NOTIFICATION;
(function (NOTIFICATION) {
    NOTIFICATION[NOTIFICATION["ALERT"] = 0] = "ALERT";
    NOTIFICATION[NOTIFICATION["ERROR"] = 1] = "ERROR";
    NOTIFICATION[NOTIFICATION["SUCCESS"] = 2] = "SUCCESS";
})(NOTIFICATION || (NOTIFICATION = {}));
const defaultApi = {
    notifications: [],
    setNotification: (notification) => null,
    clearNotification: (id) => null,
};
export const NotificationsContext = React.createContext(defaultApi);
export function NotificationsProvider({ children }) {
    const [notifications, setNotifications] = React.useState(defaultApi.notifications);
    const setNotification = React.useCallback((notification) => {
        const existing = notifications.find((n) => n.id === notification.id);
        const nextNotifications = existing
            ? notifications.map((n) => n.id === notification.id ? Object.assign(Object.assign({}, existing), notification) : n)
            : notifications.concat(Object.assign({ id: new Date().getTime().toString(), timestamp: new Date().getTime(), variant: NOTIFICATION.ERROR }, notification));
        setNotifications(nextNotifications);
    }, [notifications, setNotifications]);
    const clearNotification = React.useCallback((id) => {
        if (!id) {
            setNotifications([]);
        }
        else {
            const ids = Array.isArray(id) ? id : [id];
            const nextNotifications = notifications.filter(({ id }) => !ids.includes(id));
            setNotifications(nextNotifications);
        }
    }, [notifications, setNotifications]);
    const handleExpireNotifications = React.useCallback((currentTime) => {
        if (notifications.length) {
            const expiredIds = notifications.reduce((acc, n) => {
                const isExpired = n.timestamp <= currentTime - (n.timeout || DEFAULT_TIMEOUT);
                return isExpired && n.timeout !== null ? acc.concat(n.id) : acc;
            }, []);
            if (expiredIds.length) {
                clearNotification(expiredIds);
            }
        }
    }, [notifications, clearNotification]);
    useInterval(handleExpireNotifications, INTERVAL);
    return (_jsx(NotificationsContext.Provider, Object.assign({ value: {
            notifications,
            setNotification,
            clearNotification,
        } }, { children: children })));
}
export function useNotifications() {
    return React.useContext(NotificationsContext);
}
//# sourceMappingURL=useNotification.js.map